import { ref, watch, computed } from '@vue/composition-api'
import http from '@axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useOrdersList() {
  // Use toast
  const toast = useToast()

  const refOrderListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'order_date', label: 'Дата заказа', sortable: true },
    { key: 'msisdn', label: 'Номер заказа', sortable: true },
    { key: 'price', label: 'Цена', sortable: true },
    { key: 'fio', label: 'ФИО', sortable: true },
    { key: 'phone_number', label: 'Контактный номер', sortable: true },
    { key: 'status', label: 'Статус' },
    { key: 'documents', label: 'Документы' },
  ]
  const perPage = ref(10)
  const totalOrders = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refOrderListTable.value ? refOrderListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalOrders.value,
    }
  })

  const refetchData = () => {
    refOrderListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, statusFilter], () => {
    refetchData()
  })

  const fetchOrders = (ctx, callback) => {
    http.get('/admin/orders', {
      params: {
        keyword: searchQuery.value,
        limit: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
      },
    })
      .then(response => {
        const { data, total } = response.data

        callback(data)
        totalOrders.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  const resolveOrderStatusVariant = status => {
    if (status === 1) return 'warning'
    if (status === 0) return 'success'
    if (status === 2) return 'secondary'
    return 'primary'
  }

  return {
    fetchOrders,
    tableColumns,
    perPage,
    currentPage,
    totalOrders,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refOrderListTable,

    resolveOrderStatusVariant,
    refetchData,

  }
}
